import { useCallback, useEffect } from "react"

import { useTheme } from "next-themes"

import {
  CONTROL_OPTION_COMMAND_BACKQUOTE_SHORTCUT,
  useKeyboardShortcutsController,
} from "@/contexts/KeyboardShortcutsContext"

export function ThemeShortcut() {
  const { resolvedTheme, setTheme } = useTheme()
  const { registerShortcut, unregisterShortcut } =
    useKeyboardShortcutsController()

  const toggleTheme = useCallback(() => {
    setTheme(resolvedTheme === "dark" ? "light" : "dark")
  }, [resolvedTheme, setTheme])

  useEffect(() => {
    registerShortcut({
      action: toggleTheme,
      key: CONTROL_OPTION_COMMAND_BACKQUOTE_SHORTCUT,
      label: "Toggle light/dark mode",
      state: {
        paletteGroup: "other",
      },
    })

    return () => {
      unregisterShortcut(CONTROL_OPTION_COMMAND_BACKQUOTE_SHORTCUT)
    }
  }, [registerShortcut, toggleTheme, unregisterShortcut])

  return null
}
